import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=2ccce96e&"
import script from "./HeaderInfo.vue?vue&type=script&lang=ts&"
export * from "./HeaderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=2ccce96e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports